module.exports = __webpack_public_path__ + "static/img/logo_white_house.9a349a5f.svg";